import { render, staticRenderFns } from "./UploadDocumentsManager.vue?vue&type=template&id=3873400c&"
import script from "./UploadDocumentsManager.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports